module.exports = __webpack_public_path__ + "dist/img/teachers-logo.8469b7cc.png";